<template>
  <div class="q-pa-sm full-height ops-deploy-gray-upgrade-form">
    <rs-form
      ref="form"
      name="ten-deploy"
      :value="{ tenantMode: 'saas', type: 'upgrade', upgradeType: 'gray', upgradeMode: 1, shouldHalt: false }"
    >
      <rs-field type="group" :label="$t_s('baseInfo')">
        <rs-field name="tenantMode" readonly></rs-field>
        <rs-field name="type" readonly></rs-field>
        <rs-field name="upgradeType" readonly></rs-field>
        <rs-field name="upgradeMode" hidden></rs-field>
        <rs-field name="name"></rs-field>
        <rs-field name="shouldHalt" :readonly="disable"></rs-field>
        <rs-field name="status" readonly v-if="disable"></rs-field>
        <rs-field
          name="tenants"
          col="8"
          :readonly="disable"
          required
          :widget="{
            fields: ['id', 'name', 'uname', 'principal', 'recTime'],
            conditions: [{ key: 'deployMode', vals: ['saas'] }],
          }"
        ></rs-field>
        <rs-field
          name="info"
          col="12"
          :widget="{ _type: 'input', inputStyle: { height: '50px' }, type: 'textarea' }"
        ></rs-field>
      </rs-field>
      <rs-field type="group" name="services" label="升级的服务">
        <rs-list
          ref="list"
          name="ten-deploy-service"
          :data="serviceList"
          :loadDefault="false"
          hideBottom
          :selection="false"
        >
          <rs-field name="service.id"></rs-field>
          <rs-field name="service.name"></rs-field>
          <rs-field name="version"></rs-field>
          <rs-field type="toolbar" :include="disable ? [] : ['delete']" exclude="*"></rs-field>
          <rs-toolbar :include="disable ? [] : ['addItem']" exclude="*">
            <rs-button name="addItem" icon="add" color="primary" label="添加服务"></rs-button>
          </rs-toolbar>
        </rs-list>
      </rs-field>
      <rs-toolbar>
        <rs-button name="submit" auth="grayAdd"></rs-button>
        <rs-button name="stable" label="升级为稳定版" color="secondary" :hidden="!stableEnable"></rs-button>
        <rs-button name="hotfix" label="修复发布" color="accent" :hidden="!hotfixEnalbe"></rs-button>
        <rs-button name="cancel"></rs-button>
      </rs-toolbar>
    </rs-form>
  </div>
</template>
<script>
import ModelService from "rsui-core/src/core/model-service";
import { OP_TYPE } from "rsui-core/src/core/types";
import pick from "lodash/pick";
export default {
  components: {},
  data: function() {
    return {
      id: null,
      serviceList: [],
      modelService: new ModelService(),
      deployStatus: null,
      disable: true, // 服务列表上 按钮是否disable
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    if (this.id) {
      this.fetchServiceList(this.id);
    } else {
      // 这里时新建情况
      this.disable = false;
    }
  },
  computed: {
    stableEnable: function() {
      if (!this.id || !this.deployStatus || this.deployStatus.apvStatus !== 2 || this.deployStatus.status !== 4) {
        return false;
      }
      return true;
    },

    hotfixEnalbe: function() {
      if (!this.id || !this.deployStatus || this.deployStatus.apvStatus !== 2 || this.deployStatus.status !== 4) {
        return false;
      }
      return true;
    },
  },
  methods: {
    fetchServiceList(deployId) {
      // 查询已经保存的微服务列表
      this.modelService
        .list(
          {
            fields: ["version", "service.id", "service.name"],
            page: 1,
            size: -1,
            conditions: [{ key: "deploy.id", vals: [deployId] }],
          },
          "ten-deploy-service",
        )
        .then((resp) => {
          this.serviceList = resp.list || [];
        });
    },
    beforeRequest(e, params, eventId) {
      return {
        params,
        resolve: ({ params }) => {
          this.disable = params.apvStatus === 1 || params.apvStatus === 2;
          this.deployStatus = pick(params, ["id", "apvStatus", "status"]);
        },
      };
    },
    // 保存表单时
    beforeSubmit(e, params) {
      if (!this.id) {
        params.status = 1;
        params.apvStatus = 0;
      }
      return {
        params,
        resolve: ({ response }) => {
          if (!this.disable) {
            const id = response && response.content && response.content.id ? response.content.id : this.id;
            this.$refs.form.modelService.cascade(
              "services",
              id,
              this.serviceList.map((d) => pick(d, ["service.id", "version"])),
              "ten-deploy",
            );
          }
          this.$rs_actionRefresh("ops.saasUpgrade._view");
        },
      };
    },
    onTenDeployServiceAddItem(e) {
      e.preventDefault();
      const existServiceIds = this.serviceList.map((d) => d.service.id);
      this.$rs_model_dlg(
        {
          modelName: "ten-service-version",
          multiple: true,
          conditions: [
            { key: "apvStatus", vals: [2] }, //服务已审批
            { key: "versionType", vals: ["beta"] }, //beta版本
            { key: "deployStatus", vals: [0] },
            { key: "service.id", op: OP_TYPE.NE, vals: existServiceIds },
          ],
          fields: ["service.id", "service.name", "version", "deployStatus", "recTime"],
        },
        {
          beforeEvent: ({ name, e, selected, dlg }) => {
            // 点击是dlg 确定按钮且selected没有值时，e.preventDefault()一下，阻止它进行onOK处理,导致下次点击取消不走onCancel方法【因为global-dialog中emittedOK = true】
            if (name === "confirm") {
              if (selected.length === 0) {
                e.preventDefault();
                dlg.hide();
                return;
              }
              if (!this.checkAddService(selected)) {
                this.$rs_warning("不能同时发布相同的服务！");
                e.preventDefault();
                return;
              }
            }
          },
        },
      ).then(({ selected, dlg }) => {
        const dealedData = selected.map((d) => {
          return {
            service: d.service,
            version: d.version,
          };
        });
        this.$set(this, "serviceList", [...dealedData, ...this.serviceList]);
        dlg.hide();
      });
    },
    onTenDeployServiceDeleteBeforeConfirm(e, params, eventId) {
      e.preventDefault();
      const delIndexs = params.map((d) => d.__index);
      this.$set(
        this,
        "serviceList",
        this.serviceList.filter((d, index) => !delIndexs.includes(index)),
      );
    },
    checkAddService(list) {
      const existServiceIds = this.serviceList.map((d) => d.service.id);
      let result = true;
      list.forEach((p) => {
        const id = p.service.id;
        if (existServiceIds.includes(id)) {
          result = false;
        } else {
          existServiceIds.push(id);
        }
      });
      return result;
    },

    onTenDeployStable(e, params, eventId) {
      this.$rs_action("ops.saasFullUpgrade._add", { query: { srcDeployId: this.id } });
    },

    onTenDeployHotfix(e, params, eventId) {
      this.$rs_action("ops.saasFixUpgrade._add", { query: { srcDeployId: this.id } });
    },
  },
};
</script>
